module.exports = __webpack_public_path__ + "img/KSC09129.b839f5bf.jpg";